<template>
    <div class="googleLoginButton" ref="refGoogleLoginButton">

    <!-- Redirect method -->
    <div id="g_id_onload" 
            data-client_id="784934877165-qiph0fmp0l880763q3o9sjuqqage98mf.apps.googleusercontent.com"
            data-ux_mode="popup"
            :data-login_uri="$root.isCheckOutPage ? windowLocOrign+baseDir+'/loginServlet?mode=googleLogin&sirius=/checkout-continue' : windowLocOrign+baseDir+'/loginServlet?mode=googleLogin'"
            data-auto_prompt="false"
           >        
    </div>

    <div class="glb-responsive-wrapper">
        
        
        <div v-show="hasGoogleLoginScriptLoaded">
        
        <div class="g_id_signin" :class="this.responsiveClass=='glb-default'?'':'glb-d-none'"
        data-type="standard"
        data-shape="rectangular"
        data-theme="filled_blue"
        data-text="signin_with"
        data-size="large"
        data-width="400"
        data-logo_alignment="left">
        </div>

        <div v-for="(item,index) in googleButtonSizeArray" :key="index" class="g_id_signin" :class="responsiveClass=='glb-w'+item?'':'glb-d-none'"
        data-type="standard"
        data-shape="rectangular"
        data-theme="filled_blue"
        data-text="signin_with"
        data-size="large"
        :data-width="item"
        data-logo_alignment="left">
        </div>

        </div>

        <loadingBalls v-show="!hasGoogleLoginScriptLoaded"></loadingBalls>
   
    </div>  
    


</div>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill';
import loadingBalls from './loadingBalls.vue'

export default {
    name: "googleLoginButton",
    components: {
        loadingBalls
    },
    data() {
        return {
            // Mutation Observer
            width: null,
            height: null,
            observer: null,
            // Button Variables
            toggleLoading: true,
            googleButtonSizeArray: [200,300,400],
            padding: 0,
            googleParams: {
                client_id: '784934877165-qiph0fmp0l880763q3o9sjuqqage98mf.apps.googleusercontent.com',
                ux_mode: 'popup',
            },
            windowLocOrign: '',
            baseDir: '',
            hasGoogleLoginScriptLoaded: false,
        }
    },
    mounted(){
        //console.log(`//// ${this.$options.name} Mounted ////`);

        var googleLoginScript = document.createElement('script');
        googleLoginScript.setAttribute('src', "https://accounts.google.com/gsi/client");
        googleLoginScript.async = true;
        googleLoginScript.defer = true;
        document.head.appendChild(googleLoginScript)
        googleLoginScript.onload = ()=>{
            //console.log("Script has loaded");

            this.hasGoogleLoginScriptLoaded = true; 
        };


        this.windowLocOrign = window.location.origin;
        this.baseDir = basedir;

      // initialize the observer on mount
      this.initObserver(this.$refs.refGoogleLoginButton);

    },
    methods: {
        onResize: function() {
        const box = this.$refs.refGoogleLoginButton,
          width = box.offsetWidth,
          height = box.offsetHeight

        this.width = width
        this.height = height
        
        this.$emit('resize', { width, height })
      },
        initObserver: function(element) {
        const observer = new ResizeObserver(this.onResize)
        observer.observe(element)
        this.observer = observer
      },
      destroyObserver: function(element){
        if (this.observer) this.observer.unobserve(element);
      }

    },
    computed:{
        responsiveClass: function(){
            //console.log("responsive Class: ", this.width)

            if(this.width >= 400){
                //console.log("Container greater than 400px");
                return 'glb-w400';
            }else if(this.width <= 399 && this.width>=300){
                //console.log("Container is smaller than 400px");
                return 'glb-w300';
            }else if(this.width <= 299){
                //console.log("The container is smaller than 299")
                return 'glb-w200'
            }else{
                //console.log("The Container is smaller than 299");
                return 'glb-default'
            }

        }
    },
    beforeDestroy() {
        this.destroyObserver(this.$refs.refGoogleLoginButton);
    },
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
div .googleLoginButton .g_id_signin span,div .googleLoginButton .g_id_onload{
    color: white;
}
.googleLoginButton *{
   // all:unset;
}
.googleLoginButton{
    width:100%;
    //background: red;
    // Max-height prevents the button from doing some jumpy dancing
    max-height: 40px;
    overflow: hidden;
    .glb-responsive-wrapper{
        display:flex;
        align-items: center;
        flex-direction: column; 

    }
    .glb-d-none{
        display: none;
    }
    .g_id_signin{

        span{
            color: white!important;
        }
    }
}

</style>
